// @ts-ignore
import cls from "./Loader.module.scss";


export const Loader = () => {
    return (
        <div className={cls.loader} />
    )
}